export default "__VITE_ASSET__BqUtzYnZ__"